import { ASSIGNEE_USERS, FROM, LINKED_INTERVENTION, NOT_EXIST, SEARCH, SORT, STATUS, TO } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import type { MayBe } from 'modules/global/typing/common/common';
import * as types from 'modules/leads/actionTypes';
import type { LeadsDashboardFilters, SetLeadsFiltersAction } from 'modules/leads/types';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

const persistedFilters: MayBe<Partial<LeadsDashboardFilters>> = getPersistedFilters()?.filters?.leads;

const baseState: LeadsDashboardFilters = {
  [TO]: null,
  [FROM]: null,
  [STATUS]: [],
  [SEARCH]: null,
  [NOT_EXIST]: [],
  [ASSIGNEE_USERS]: [],
  [SORT]: 'createdOn,desc',
  [LINKED_INTERVENTION]: null,
};

const setFilters = (state: LeadsDashboardFilters, { payload }: SetLeadsFiltersAction): LeadsDashboardFilters => ({
  ...state,
  ...payload,
});

const filterAdapter = filterSliceAdapter(baseState, persistedFilters ?? {});

export default createReducer<LeadsDashboardFilters>(filterAdapter.getInitialState(), {
  [types.SET_LEADS_FILTER]: filterAdapter.setFilter,
  [types.SET_LEADS_FILTERS]: setFilters,
  [types.CLEAR_LEADS_FILTERS]: filterAdapter.resetFilters,
  [types.REMOVE_LEADS_FILTER]: filterAdapter.removeFilter,
});
